import React from "react";
import "./SlidableComponent.css";
import { motion } from "framer-motion";
import Tick from "../../../svg/Tick";
import Arrow from "../../../svg/Arrow";

const SlidableComponent = ({ title = "", grid = [], list = [], data, i }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggleOpen = () => {
    setIsOpen((prev) => !prev);
  };

  const pumperDate = () => {
    const dateISO = data?.find((item) => item?.date)?.date;

    if (!dateISO) return null;

    const date = new Date(dateISO);

    return `${String(date.getDate()).padStart(2, "0")}.${String(
      date.getMonth() + 1,
    ).padStart(2, "0")}.${date.getFullYear()}, ${String(
      date.getHours(),
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
  };

  const renderFields = (item, fields) => {
    return fields.map((field) => {
      const value = item?.[field.key];

      if (value === null || value === undefined) return null;

      // Специальный рендер для длины стрелы, чтобы убрать "м" в конце и добавить единицу измерения
      if (field.key === "arrowLength" && typeof value === "string") {
        return (
          <div key={field.key} className={"numberValue"}>
            <span className={"label"}>{field.label}: </span>
            <span className={"value"}>{value.slice(0, -1)} м</span>
          </div>
        );
      }

      // Специальный рендер для кол-ва труб
      if (typeof value === "number" && field.key === "pipes" && value > 0) {
        return (
          <div key={field.key} className={"numberValue"}>
            <span className={"label"}>{field.label}: </span>
            <span className={"value"}>{value}</span>
          </div>
        );
      }

      return (
        <div key={field.key}>
          {typeof value === "boolean" && value && (
            <div className={"booleanValue"}>
              <Tick />
              <span className={"value"}>{field.label}</span>
            </div>
          )}

          {typeof value === "number" && value > 0 && (
            <div className={"numberValue"}>
              <span className={"label"}>{field.label}: </span>
              <span className={"value"}>{value} м</span>
            </div>
          )}

          {typeof value === "string" && value.length > 0 && (
            <div className={"stringValue"}>
              <span className={"label"}>{field.label}: </span>
              <span className={"value"}>{value}</span>
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <div className={"wrapper"}>
      <div className={"header"}>
        <div className={"option"}>
          <span className={"title"}>{title} </span>
          <span className={"title"}>{i}</span>
          <span className={"date"}>{pumperDate()}</span>
        </div>
        <div
          style={{ transform: isOpen ? "rotate(90deg)" : "rotate(0deg)" }}
          onClick={toggleOpen}
        >
          <Arrow />
        </div>
      </div>
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{
          height: isOpen ? "auto" : 0,
          opacity: isOpen ? 1 : 0,
        }}
        transition={{ duration: 0.3 }}
      >
        <div className={"content"}>
          {data.map((item, index) => (
            <div className={"grid"} key={index}>
              {renderFields(item, grid)}
            </div>
          ))}

          {data.map((item, index) => (
            <div className={"list"} key={index}>
              {renderFields(item, list)}
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default SlidableComponent;
